export default __webpack_public_path__ + "media/images/mailer/logo-3968604c305e61cf4d684b2d54971593.png";